export const ROUTES_CONFIG = {
  route: {
    key: "name",
    label: "Ruta",
  },
  station: {
    key: "station",
    label: "Planta",
  },
  employee: {
    key: "employee",
    label: "Empleado",
  },
};

export const ROUTES_PHRASE = {
  page: {
    table: {
      title: "Catalogo de Rutas",
    },
  },
  modal: {
    titles: {
      edit: "Modificar Ruta",
      add: "Agregar Nueva Ruta",
      delete: "¿Estas seguro de eliminar esta Ruta?",
    },
    actions: {
      cancel: "Cancelar",
      add: "Agregar",
      delete: "Eliminar",
      save: "Guardar",
    },
  },
  search: {
    messages: {
      noStations: "No se ha seleccionado alguna planta.",
    },
  },
  form: {
    dropdowns: {
      station: "Seleccione una Planta",
      employee: "Seleccione un Empleado",
    },
  },
};
